export const light = {
  title: "light",
  colors: {
    primary: "#717CFF",
    background: "#FAFAFA",

    purple: "#ebedff",

    blue: "#5C96FF",
    orange: "#FA706C",
    green: "#70CE88",

    black: "#373737",
    black2: "#565656",
    black3: "#2F2F2F",

    gray: "#7D7D7D",
    gray2: "#37474F",
    gray3: "#ddd",
    white: "#fff",

    danger: "#FF5959",
  },
};
